<template>
  <v-card class="mx-auto top10" max-width="auto">
    <v-card-text>
      <p class="text-h6 text--primary">{{ title }}</p>
      <v-alert
        border="top"
        v-if="!check.isSynchronized && !isSynchronizing"
        color="red darken-1"
        dark
      >
        {{ errorText }}
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          color="primary"
          @click="onSynchronize"
        >
          <v-icon dark> mdi-cached </v-icon>
        </v-btn>
      </v-alert>

      <v-alert v-if="isSynchronized" type="success" border="top">
        Чек успешно синхронизирован
      </v-alert>

      <v-progress-linear
        v-if="isSynchronizing"
        indeterminate
        color="primary"
      ></v-progress-linear>

      <p>{{ check.contractNumber }}</p>
      <p>{{ check.contractorName }} ({{ check.email }})</p>
      <p>{{ check.deliveryAddress }}</p>
      <p><v-divider></v-divider></p>
      <p><b>Сумма</b>: {{ check.amount }} <span class="currency-rub"></span></p>
      <p>
        <b>Дата</b>: {{ check.createDate | moment("D MMM YYYY, HH:mm:ss") }}
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CheckListRow",
  props: ["check", "index"],
  data: () => ({
    isSynchronizing: false,
    isSynchronized: false,
    errorText: "Чек не синхронизирован",
  }),
  computed: {
    title() {
      return this.check.updNumber ? "УПД № " + this.check.updNumber : "Аванс";
    },
  },
  methods: {
    onSynchronize() {
      this.isSynchronizing = true;
      this.$store
        .dispatch("synchronize_check", this.check.id)
        .then(() => {
          this.$store.commit("synchronizeCheck", this.check.id);
          this.isSynchronized = true;
        })
        .catch((err) => {
          this.errorText = JSON.parse(err.request.responseText);
        })
        .finally(() => {
          this.isSynchronizing = false;
        });
    },
  },
};
</script>
